module.exports = __webpack_public_path__ + "activities_fg_2.f2b829532c4fdc6ecf3fabb5dc7ee7c3.png";